/* eslint-disable promise/always-return */
/* eslint-disable max-len */
/* eslint-disable no-useless-escape */
import React, { useEffect } from 'react'
import { Modal, Text, TextInput } from '..'
import { IconButton } from '@material-ui/core'
import { colors } from '../../Themes'
import ClearIcon from '@material-ui/icons/Clear'
import { SecondaryOutlinedButton3, SecondaryOutlinedButton4 } from '../Button/Button'
import { errorIcon, info } from '../../Themes/Images'
import referralCodeStyles from './ReferalCodeModal.styles'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'

function containsSpecialChars(str) {
  const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/
  return specialChars.test(str)
}

function ReferalCodeModal({ isVisible, onCancel, checkout, checkoutWithCode, handleChange, value, handleOnBlur, error, isDisabled, setDisabled, isLoading, setLoading }) {
  const classes = referralCodeStyles()

  useEffect(() => {
    if (
      value !== '' && value.length === 8 && !containsSpecialChars(value)
    ) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }, [value, setDisabled ])

  return (
    <Modal type="noBlur" costumizedPaperStyles={classes.paperCostum} opened={isVisible}>
      <div className={classes.ModalWrapper}>
        <div className={classes.subModal}>
          <div className={classes.text}>
            <Text size='h5' color={colors.purple} weight='bold' >Redeem Referral Code</Text>
          </div>
          <IconButton
            disableFocusRipple
            centerRipple={true}
            disableRipple={true}
            style={{ backgroundColor: 'transparent' }}
            classes={{ root: classes.iconButtonClose }}
            onClick={onCancel}
          >
            <ClearIcon classes={{ root: classes.closeIcon }} />
          </IconButton>
        </div>
        <div className={classes.divider}>
        </div>
        <div className={classes.textTitle}>
          <Text size='subnote' color={colors.primary} className={classes.spaceText2}>Find the referral code in your <b>friend&apos;s invite.</b> You can skip this step if you don&apos;t have one.</Text>
        </div>
        <TextInput
          name='code'
          costumizedInputStyles={classes.input}
          label='Enter the Referral code (optional)'
          value={value}
          onChange={handleChange}
          onBlur={handleOnBlur}
        />
        {error &&
          <div className={classes.errorDiv}>
            <img className={classes.errorICon} src={errorIcon} />
            <Text className={classes.errorText} color={colors.secondary} size='footnote'>{error?.response?.data?.error?.message}</Text>
          </div>
        }
        <div className={classes.noteWrapper}>   
          <img className={classes.info} width={24} height={24} src={info} />
          <Text size='footnote'>
            <Text className={classes.note} weight='medium' size='subnote'>Note:&nbsp;</Text> 
            This is not a discount code.&nbsp;
            {/* <a
              className={classes.link}  
              href='https://www.google.com'
              target='_blank' 
              rel="noreferrer"
            >Learn more
            </a> */}
          </Text>
        </div>
        <div className={classes.divider} style={{ marginTop: 25 }} />
        <div className={classes.buttonsWrapper}>
          <SecondaryOutlinedButton4
            className={classes.cancelButton}
            onClick={() => checkout()}
            style={{ border: '1px solid #cccccc' }}
          > Skip
          </SecondaryOutlinedButton4>
          <SecondaryOutlinedButton3
            className={classes.nextButton}
            disabled={isDisabled || isLoading}
            loading={isLoading}
            style={{
              backgroundColor: isDisabled || isLoading ? colors.disabled : colors.primary,
              color: colors.white,
            }}
            onClick={() => checkoutWithCode()}
          >
            Continue
          </SecondaryOutlinedButton3>
        </div>
      </div>
    </Modal>
  )
}

export default ReferalCodeModal  